export enum BPRouterItems {
  COMPANIES = 'companies',
  ALERTS = 'alerts',
  DOCUMENTS = 'documents',
  INTERNAL_TRANSFERS = 'internal-transfers',
  CONTACTS = 'contacts',
  USERS = 'users',
  CLIENT_USER_MANAGEMENT = 'client-users-management',
  APPLICATIONS = 'applications',
  HISTORY = 'history',
  BSA = 'bsa',
  ADVERSE_MEDIA = 'adverse-media',
  REPORTS = 'reports',
  ACCOUNT_SETTINGS = 'account-settings',
  NEXT_CLOUD_LOGIN = 'next-cloud-login',
  SALES_DATA_CONNECTIONS = 'sales-data-connections',
  CRB_MONITOR = 'crb-monitor',
  // CONNECTIONS_HEADER = true if (SALES_DATA_CONNECTIONS || CRB_MONITOR)
  CONNECTIONS_HEADER = 'connections-header',
  SETUP_ONBOARDING_DOCUMENTS = 'setup-onboarding-documents'
}
